import browser, { BROWSER_LIST } from './browser-detect';
import { BACK_FROM_KIOSK, INVOICE_PRINT_DATA } from './jsBridgeEvents';

let handler = (_event_name, _data)=>{};

if (browser === BROWSER_LIST.SAFARI) {
	if (typeof window !== "undefined" && window) {
		handler = function (event_name, data) {
			try {
				if(event_name === INVOICE_PRINT_DATA 
					&& window?.webkit?.messageHandlers?.invoicePrintData?.postMessage){
					window?.webkit?.messageHandlers?.invoicePrintData?.postMessage(
						JSON.stringify({
							event: event_name,
							data,
						}))
				} else if(event_name === BACK_FROM_KIOSK
					&& window?.webkit?.messageHandlers?.invokeBackFromKiosk?.postMessage){
					window?.webkit?.messageHandlers?.invokeBackFromKiosk?.postMessage(
						JSON.stringify({
							event: event_name,
							data,
						}))
				}
			} catch (err) {
				console.log(err)
			}
		}
	}
}

export default handler;